
// String includes polyfill
// For: IE 11, Chrome < 41, Firefox < 40, Safari < 9

if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    start = (typeof start !== 'number') ? 0 : start;
    return (start + search.length > this.length) ? false : this.indexOf(search, start) !== -1;
  };
}



// WEBPACK FOOTER //
// ./website/vendor/scripts/fabrique/polyfills/string-includes.js